import { CanActivateFn } from '@angular/router';

export const officeGuard: CanActivateFn = () => {
  let userProfile = JSON.parse(sessionStorage.getItem('user') || '{}');
  if (!userProfile || !userProfile.security || !userProfile.security.officeTab)
    return false;
  else return true;
};